import useSWR from "swr";
import { api } from "../services";
import { PaginatedResult } from "../utils/pagination";

const APPLICANT_URL = "/system-admin/applicant";
const BASE_URL = "/system-admin/offerletter";

export const useOfferLetter = (initialParams) => {
  const { type = "" } = initialParams || {};

  const getApplicants = async (status = "", pageNumber = 1, pageSize = 10, search = "") => {
    const query = new URLSearchParams();
    query.append("pageNumber", pageNumber);
    query.append("pageSize", pageSize);

    if (search) query.append("search", search);
    if (type && type !== "all") query.append("type", type);

    const response = await api.getPaginated(`${APPLICANT_URL}/${status}?${query.toString()}`);
    return new PaginatedResult(response.data, response.pagination);
  };

  const create = async (data) => {
    const offerLetter = await api.post(`${BASE_URL}/create`, data);
    return offerLetter;
  };

  const update = async (id, data) => {
    const offerLetter = await api.patch(`${BASE_URL}/${id}/edit`, data);
    return offerLetter;
  };

  const find = async (query) => {
    const offerLetter = await api.get(`${BASE_URL}/find?search=${query}`);
    return offerLetter;
  };

  const getById = async (id) => {
    const response = await api.get(`${BASE_URL}/${id}`);
    return response;
  };

  return {
    getApplicants,
    create,
    update,
    find,
    getById,
  };
};

export const useOfferLetterById = (id) => {
  const { data, isLoading, mutate } = useSWR(id ? `${BASE_URL}/applicant/${id}` : null, api.get);

  const remove = async (id) => {
    const offerLetter = await api.delete(`${BASE_URL}/${id}`);
    return offerLetter;
  };

  return {
    isLoading: id ? isLoading : false,
    data,
    mutate,
    remove,
  };
};